"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-base@0.4.7@@antv/g-base/lib/interfaces.js
// module id = T+Pq
// module chunks = 14